import './IconMinus.css';
import React from 'react';
const IconMinus = _ref => {
  let {
    width = 20,
    height = 20,
    className = ''
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 20 20",
    className: `${className} ${styles}`
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5 9h10v2H5z"
  }));
};
const styles = "s1tu5dv2";
export default IconMinus;